import { ReactComponent as SearchIcon } from '../../../../../../assets/vectors/search.svg';
import { UpdateProspectStatusQueryParams } from './DashboardProspectsCOMTable.types';
import { useProspects } from '../../../../../../hooks/fetchers/useProspects/useProspects';
import Select from '../../../../../commons/Select/Select';
import {
  ProspectStatus,
  SearchProspectsFromCOMResponse,
} from '../../../../../../types/api/endpoints/prospect/prospect.types';
import { useMutation, useQueryClient } from 'react-query';
import {
  SEARCH_PROSPECT_QUERY_KEY,
  UPDATE_PROSPECT_STATUS_QUERY_KEY,
  searchProspectFromCOMQuery,
  updateProspectStatusQuery,
} from './DashboardProspectsCOMTable.query';
import { BaseResponse } from '../../../../../../types/api/api.types';
import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import SearchInput from '../../../../../commons/SearchInput/SearchInput';
import { useMergedStatesFromFetchers } from '../../../../../../hooks/useMergedStatesFromFetchers/useMergedStatesFromFetchers';
import Loading from '../../../../../commons/Loading/Loading';
import Pagination from '../../../../../commons/Pagination/Pagination';

export default () => {
  const queryClient = useQueryClient();

  const [searchResults, setSearchResults] = useState<SearchProspectsFromCOMResponse>();

  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(25);

  const { data: prospects, isLoading: isProspectsLoading } = useProspects({
    page: currentPage,
    perPage: itemsPerPage,
  });

  const { mutate } = useMutation<Awaited<BaseResponse>, Error, UpdateProspectStatusQueryParams>(
    (data) => updateProspectStatusQuery(data),
    {
      mutationKey: UPDATE_PROSPECT_STATUS_QUERY_KEY,
      onMutate: () => queryClient.cancelMutations(),
      onSuccess: ({ message }) => {
        alert(message);
      },
      onError: async (error) => alert(error.message),
    }
  );

  const { mutate: searchMutate, isLoading: isSearchLoading } = useMutation<
    Awaited<SearchProspectsFromCOMResponse>,
    Error,
    string
  >((data) => searchProspectFromCOMQuery(data, { page: currentPage, perPage: itemsPerPage }), {
    mutationKey: SEARCH_PROSPECT_QUERY_KEY,
    onMutate: () => queryClient.cancelMutations(),
    onSuccess: (response) => {
      setSearchResults(response);
    },
    onError: (error) => {
      console.log('error', error);
    },
  });

  const onChangeSearchText = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      if (value.length === 0) {
        setSearchResults(undefined);
      } else {
        searchMutate(value);
      }
    },
    [searchMutate]
  );

  const numberOfPages = useMemo(() => {
    if (searchResults) {
      // @ts-ignore
      return parseInt(searchResults.total / itemsPerPage);
    } else {
      // @ts-ignore
      return parseInt(prospects?.total / itemsPerPage);
    }
  }, [prospects, searchResults, itemsPerPage]);

  const { isLoading } = useMergedStatesFromFetchers({
    loadings: [isProspectsLoading, isSearchLoading],
  });

  return (
    <div className="dashboard-commerciaux">
      <div className="dashboard-commerciaux__header">
        <SearchInput
          placeholder="Chercher un prospect..."
          startIcon={SearchIcon}
          onChange={onChangeSearchText}
        />
      </div>
      {isLoading ? (
        <Loading />
      ) : (
        <table className="dashboard__table dashboard-commerciaux__table">
          <thead>
            <tr>
              <th>Entreprise</th>
              <th>Contact</th>
              <th>Adresse email</th>
              <th>N° de téléphone</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            {(searchResults || prospects)?.results.map(
              ({ id, name_company, name, email, phone, status }, index) => (
                <tr key={index} className='dashboard-commerciaux__table-tr--clickable'>
                  <td>{name_company}</td>
                  <td>{name}</td>
                  <td>{email}</td>
                  <td>{phone}</td>
                  <td>
                    <Select
                      options={Object.values(ProspectStatus).map((status) => ({
                        value: status,
                        label: status,
                      }))}
                      // @ts-ignore
                      defaultValue={{ label: status, value: status }}
                      // @ts-ignore
                      onChange={({ value }: SelectOption) => {
                        mutate({ status: value, id, email });
                      }}
                      disabled={status === ProspectStatus.Gagné}
                    />
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      )}
      {!isLoading && numberOfPages > 0 && (
        <Pagination {...{ currentPage, setCurrentPage, numberOfPages }} />
      )}
    </div>
  );
};
